<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <div v-if="header === 'office' ">
                                <button type="button" class="btn btn-link"  @click="sortBy('inventory_name')">{{ header }} &#8597;</button>
                            </div>
                            <div v-else>
                                <span class="btn-link">{{ header }}</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="isLoading">
                        <td :colspan="table_headers.length"><span class="spinner visible anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!access.data?.length">
                        <td :colspan="table_headers.length">No results</td>
                    </tr>
                    <tr v-for="item in access.data" v-bind:key="item.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'inventory_name'">
                                <a :href="`/centre/inventory/${item.id}`">{{ item[column] }}</a>
                            </div>
                            <div v-else-if="column === 'time_period'" class="text-nowrap">
                                 <span>{{ $formatDate(item.start_date, user_date_format) }} / {{ $formatDate(item.end_date, user_date_format) }}</span>
                            </div>
                            <div v-else-if="column === 'hours'" class="text-nowrap">
                                <span>{{ item[column] }}</span>
                            </div>
                            <div v-else-if="column === 'centre_name'">{{ item[column] }}</div>
                            <div v-else v-html="item[column]"></div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="access" :limit=3 @pagination-change-page="getAccessItems">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FutureAccessDataTable",
    props: {
        api_endpoint: {
            type: String,
        },
        user_date_format: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            access: {},
            paginate: 10,
            sort_key: 'inventory_name',
            reverse: false,
            isLoading: true,
        }
    },
    watch: {
        paginate: function (value) {
            this.getAccessItems();
        },
        search: function search(value) {
            this.getAccessItems()
        },
    },
    methods: {
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? ! this.reverse : false;
            this.getAccessItems();
        },
        getAccessItems(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
                .then(response => {
                    this.access = response.data;
                    this.isLoading = false;
                });
        }
    },
    mounted() {
        this.getAccessItems();
    }
}
</script>
<style scoped>
.btn-link,.btn-link:hover {
    letter-spacing: normal;
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
    white-space: nowrap;
}
</style>
